import { type UseMutationResult, useMutation } from 'react-query';
import {
  ParticipantSignUpService,
  Wealthlane_CustomerService_Dtos_ParticipantSignUp_HasPptSignedUpRequest,
} from '../../services/wealthlane-customer-services';
import { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../../services/wealthlane-award-services';

const usePostHasPptSignedUp = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess?: any
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  Wealthlane_CustomerService_Dtos_ParticipantSignUp_HasPptSignedUpRequest,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        ParticipantSignUpService.postApiCustomerApiParticipantHasPptSignedUp(payload)
      );
    },
    {
      onSuccess,
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostHasPptSignedUp;
